import { sport as sportReference } from '@letsdothis/reference-data';
import { funcState } from '../../utils/funcState';
import { Filters } from '../utils/filtersEnum';

const SportProvider = ({ updateFilter }) => {
  const [locale, setLocale] = funcState();
  const [sportId, setSportId] = funcState();
  const [sportLabel, setSportLabel] = funcState();
  const availableSports = sportReference
    .filter((n) => !!n.slug)
    .map((s) => ({
      id: s.id,
      label: s.label,
      slug: s.slug,
    }));

  const update = ({ categoryData, locale: localeProp }) => {
    setLocale(localeProp);
    setSportId(categoryData?.sport?.id);
    setSportLabel(categoryData?.sport?.label);

    if (categoryData && !categoryData.sport) {
      setSportId(-1);
      setSportLabel('All Events');
    }

    updateFilter({
      key: Filters.Sport,
      value: { id: sportId.value, label: sportLabel.value, availableSports },
    });
  };

  const pushHistory = (obj) => {
    if (!obj?.sportId) {
      return null;
    }

    if (obj.sportId === -1) {
      return `/${locale.value}/all-events`;
    }

    const sport = availableSports.find((n) => n.id === obj.sportId);

    if (!sport) {
      return null;
    }

    return `/${locale.value}/${sport.slug}`;
  };

  const defaultFilters = {
    sportId: -1,
  };

  return { exposed: {}, update, pushHistory, defaultFilters };
};

export default SportProvider;
